import React, { FC, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import Button from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
  Summary,
  TotalItem,
} from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import { MONEY_FORMAT } from 'constants/formats';
import { DateRangeBox, Template } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { onExporting } from './utils';

const ConsumptionNomenclatureSalary: FC = () => {
  const history = useHistory();
  const refGrid = useRef<DataGrid | null>(null);

  const [dateBegin, setDateBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment(new Date()).format('YYYY-MM-DD'));

  const salaryDataStore: any = useMemo(() => {
    return $createStore(`/v1/driverMixerSalary?dateBegin=${dateBegin}&dateEnd=${dateEnd}`, 'id');
  }, [dateBegin, dateEnd]);

  const openEmployeeInfoHandler = (id: number) => {
    history.push(`/salary-mixers/${id}?dateBegin=${dateBegin}&dateEnd=${dateEnd}`);
  };

  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');

  const onExportingHandler = (e: any) => {
    onExporting(e, `${dateBeginText} - ${dateEndText}`);
  };

  const refresh = () => refGrid.current?.instance.refresh();

  const handleChangeDate = (dateRange: Array<string | Date | number>) => {
    dateRange[0] && setDateBegin(dateRange[0].toString());
    dateRange[1] && setDateEnd(dateRange[1].toString());
  };

  return (
    <div className="container-dev">
      <AppLayoutTop title="Оплата миксеристам">
        <DateRangeBox
          value={[dateBegin, dateEnd]}
          onValueChanged={(e) => handleChangeDate(e.value)}
          dateSerializationFormat="yyyy-MM-dd"
          stylingMode="underlined"
          useMaskBehavior
          className="mr-2"
        />
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={salaryDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          onRowDblClick={(e) => openEmployeeInfoHandler(e.data.id)}
          onExporting={onExportingHandler}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'refresh',
            });
          }}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="comingNomenclatureSalaryMixer" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Template name="refresh">
            <Button icon="refresh" onClick={refresh} />
          </Template>
          <Column dataField="employeeName" caption="ФИО" />
          <Column dataField="factoryName" caption="Площадка" width={200} />
          <Column dataField="salary" caption="Начислено, руб" format={MONEY_FORMAT} width={190} />
          <Column dataField="adjustments" caption="Корректировка" format={MONEY_FORMAT} width={190} />
          <Column dataField="total" caption="К оплате" format={MONEY_FORMAT} width={190} />
          <Column dataField="issued" caption="Выдано" format={MONEY_FORMAT} width={190} />
          <Column
            dataField="actions"
            caption=""
            cellRender={(data) => (
              <div className="d-flex justify-end">
                <Button
                  type="default"
                  stylingMode="text"
                  onClick={() => openEmployeeInfoHandler(data.data.id)}
                  text="Детализация"
                />
              </div>
            )}
            allowFiltering={false}
            allowSorting={false}
            allowSearch={false}
          />
          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
          <Summary>
            <TotalItem column="salary" summaryType="sum" displayFormat="Итого: {0}" />
            <TotalItem column="total" summaryType="sum" displayFormat="Итого: {0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ConsumptionNomenclatureSalary;
